module.exports = __webpack_public_path__ + "static/media/miscellaneous.37c3cb26.svg";